import { Button, assets } from '@round/whitelabel-ui';
import styles from './PostUrlClipboardButton.module.css';
import cn from 'classnames';
import { Tooltip } from '@round/whitelabel-ui';

const { Download: DownloadIcon } = assets;

type Props = Omit<React.ComponentPropsWithoutRef<typeof Button>, 'appearance'>;

const PostUrlClipboardButton = ({ className, ...props }: Props) => {
    return (
        <Tooltip.Root>
            {(anchor, setAnchor) => (
                <>
                    <Button appearance="outline" className={cn(styles.button, className)} {...props} ref={setAnchor}>
                        <DownloadIcon className={styles.icon} />
                    </Button>
                    <Tooltip anchorElement={anchor}>
                        <Tooltip.Title>Copy Post URLs</Tooltip.Title>
                        <Tooltip.Body>Copy all campaign post URLs to a clipboard table/spreadsheet</Tooltip.Body>
                    </Tooltip>
                </>
            )}
        </Tooltip.Root>
    );
};

export { PostUrlClipboardButton };
